import { Feedback } from 'types/feedback';

export const getUserFeedback = (feedbacks: Feedback[], userId: string) => {
  return feedbacks.find(({ creator }) => creator.id === userId);
};
